import React,{useState,useEffect} from 'react';
import {Container, Grid,Typography,Button} from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import { PREPAY_PLAN_URL } from '../eir-prepay-constants/ApplicationConstants';

function OrderDetails(props){
    const[handsetName,setHandsetName]=useState(null);
    const[handsetColorName,setHandsetColorName]=useState(null);
    const[handsetImage,setHandsetImage]=useState('/.galleries/eir/devices/handset_not_found.png');
    const[handsetPrice,setHandsetPrice]=useState(null);    
    const[planTitle,setPlanTitle]=useState(null);
    const[planPriceText,setPlanPriceText]=useState(null);
    const[planDeviceType,setPlanDeviceType]=useState(null);
    useEffect(()=>{
            if(props.details.device){
                handsetDetails(props.details);
            }
            if(props.details.plan){
                planDetails(props.details.plan);
            } 
    },[props]);
    const handsetDetails = (details) => {
        try {
            setHandsetName(details.device.name);
            document.querySelector('.mobile-color').style.backgroundColor=(details.device.variants[0].colour=='#ffffff' || details.device.variants[0].colour=='#FFFFFF' ?'#F3F3F3' :details.device.variants[0].colour)
            setHandsetColorName(details.device.variants[0].name);
            if(details.device.variants[0].image)
                setHandsetImage(details.device.variants[0].image.path);
            if(details.discount){
                setHandsetPrice(phonePriceCalculation(String(details.device.fromPrice),true));
            }else{
                setHandsetPrice(phonePriceCalculation(details.device.price,true)); 
            }            
        } catch (err) {
            console.log(err.message);
        }
    };
    const planDetails = (plan) => {
        try {
            if(plan.attributes.filter(attribute => attribute.name === 'strapline').length !=0)
                setPlanTitle(priceCalculation(plan.price,false)+' '+plan.attributes.filter(attribute => attribute.name === 'strapline').map(attribute => attribute.value));
            else
                setPlanTitle(priceCalculation(plan.price,false)+' '+plan.attributes.filter(attribute => attribute.name === 'mainfeature').map(attribute => attribute.value));
            setPlanPriceText(priceCalculation(plan.price,true));
            setPlanDeviceType(plan.attributes.filter(attribute => attribute.name === 'feature')[0].value);
        } catch (err) {
            console.log(err.message);
        }
    };
    const priceCalculation = (amount,decimal) => {
        var price = (amount)+'';
        var prices = price.split('.');
        if (prices[0].charAt(0) === '0') {
            prices[0] = prices[0].substr(1);
        }
        if(prices[1]==undefined && decimal==true){
            prices[1]='00';
        }  
        var priceText='';
        if(prices[1]==undefined)
            priceText=prices[0];
        else
            priceText=prices[0]+'.'+prices[1]
        return priceText;
    }
    const phonePriceCalculation = (amount,decimal) => {
        var price = (amount)+'';
        var prices = price.split('.');
        if (prices[0].charAt(0) === '0') {
            prices[0] = prices[0].substr(1);
        }
        if(prices[1]==undefined && decimal==true){
            prices[1]='00';
        }  
        var priceText='';
        if(prices[1]==undefined)
            priceText=prices[0];
        else
            priceText=prices[0]+'.'+prices[1]
        return priceText;
    }
    
    
    return (      
              <Container className='background'>
                <Grid container variant='outlined'>                    
                           <Grid xs={12} sm={12}>
                                {/*START PLAN SECTION*/} 
                                {props.details.plan?
                                 <Grid container>
                                 <Grid xs={12} sm={3} >
                                     <h2 className='h2-title'>Your plan</h2>
                                 </Grid>
                                 <Grid container xs={12} sm={9}>
                                     <Grid list xs={8} sm={6}>
                                         <Typography className='plan-title'>Prepay Plan &euro;{planTitle}</Typography>
                                     </Grid>  
                                     <Grid list xs={4} sm={6}>
                                         <Typography className='price-text'>&euro;{planPriceText}</Typography>
                                     </Grid> 
                                     <Grid container xs={12} sm={8} className='min-height'> 
                                         <Grid list xs={8} sm={8}>
                                             <Typography className='device-type'>{planDeviceType}</Typography>
                                         </Grid>  
                                     <   Grid list xs={8} sm={8} className='href-text' >
                                             <a href= {PREPAY_PLAN_URL} >Change plan</a>   
                                         </Grid>                
                                     </Grid>                
                                 </Grid>
                             </Grid> 
                                :<Grid container>
                                <Grid xs={12} sm={3} >
                                    <h2 className='h2-title'>Your plan</h2>
                                </Grid>
                                <Grid container xs={12} sm={9}>
                                    <Grid list xs={12} sm={12}>
                                        <Typography className='plan-title'>You must select a plan to complete your order</Typography>
                                    </Grid>  
                                    <Grid list className='btn-emptyplan'>
                                    <Button
                    className="handset-button"
                    onClick={() => {window.location.href =PREPAY_PLAN_URL}}
                    >Select your plan</Button>
                                    </Grid>
                                </Grid>
                                <hr className='hr-line'></hr>
                            </Grid> }
                               
                                {/*END PLAN SECTION*/} 
                                {props.details.device && props.details.plan ? <hr className='hr-line'></hr>:''}
                                
                                {/*START HANDSET SECTION*/}
                                {props.details.device?
                                <Grid container>
                                <Grid xs={12} sm={3} >
                                <h2 className='h2-title'>Your phone</h2>
                                </Grid>
                                <Grid container xs={12} sm={9}>
                                    <Grid container xs={8} sm={6} >
                                        <Grid xs={12} sm={6}>
                                            <Typography className='plan-title'>{handsetName}</Typography>
                                        </Grid>
                                        <Grid container xs={12} sm={6}>
                                            <Grid>
                                                <div  className='mobile-color'></div>
                                            </Grid>
                                            <Grid>
                                                <Typography  className='device-color'>{handsetColorName}</Typography>   
                                            </Grid>
                                        </Grid>
                                    </Grid>  
                                    <Grid list xs={4} sm={6}>
                                            <Typography className='price-text'>&euro;{handsetPrice}</Typography>
                                    </Grid> 
                                    <Grid container xs={8} sm={6} className='min-height'> 
                                        <Grid list xs={12} sm={12}>
                                            <Typography className='device-type'>&euro;{handsetPrice} with eir mobile prepay</Typography>
                                        </Grid>  
                                        <Grid list xs={12} sm={8} className='href-text' >
                                            <a href='/mobile/phones/prepay/'>Change phone</a>   
                                        </Grid>                
                                    </Grid>   
                                    <Grid container xs={4} sm={6}>  
                                        <Grid >
                                            <Avatar variant="square" className='mobile' src={handsetImage}></Avatar>
                                        </Grid>                
                                    </Grid>              
                                </Grid>
                            </Grid> 
                                :''}
                                
                                {/*END HANDSET SECTION*/} 
                            </Grid>
                </Grid>              
              </Container>
         ); 

}export default OrderDetails;